import { Mode } from "../../../../../util/enums";

export const MAPPING_IMAGE_SHIPMENT_TYPE: any = {
  // eslint-disable-next-line global-require
  [Mode.Sea]: require("Assets/img/boat-icon.svg"),
  // eslint-disable-next-line global-require
  [Mode.Air]: require("Assets/img/airplane-icon.svg"),
};

export const GLOBAL_STATE_SHIPMENT: any = {
  // eslint-disable-next-line global-require
  [Mode.Air]: "GRID_SHIPMENT_AIR",
  // eslint-disable-next-line global-require
  [Mode.Sea]: "GRID_SHIPMENT_SEA",
  // eslint-disable-next-line global-require
  [Mode.Road]: "GRID_SHIPMENT_ROAD",
};